module.exports = __webpack_public_path__ + "static/media/Meetup_Logo.c89d9a20.png";